(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["good-jinx-between-us"] && !Shopify.designMode) return;
  try {
    
function initBetweenUs(){document.querySelectorAll('[data-between-reader]').forEach(reader=>{if(reader.dataset.ready)return;reader.dataset.ready='true';const pages=Array.from(reader.querySelectorAll('[data-between-page]'));let current=0;const prev=reader.querySelector('[data-between-prev]'),next=reader.querySelector('[data-between-next]'),count=reader.querySelector('[data-between-count]');const show=i=>{if(!pages.length)return;current=Math.max(0,Math.min(pages.length-1,i));pages.forEach((p,n)=>p.hidden=n!==current);prev.disabled=current===0;next.disabled=current===pages.length-1;count.textContent=(current+1)+' / '+pages.length};prev.addEventListener('click',()=>show(current-1));next.addEventListener('click',()=>show(current+1));show(0)})}initBetweenUs();document.addEventListener('shopify:section:load',initBetweenUs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["good-jinx-members"] && !Shopify.designMode) return;
  try {
    
function initGoodJinxCountdowns(){document.querySelectorAll('[data-gjm-countdown]').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const target=Date.parse(el.dataset.target);if(!Number.isFinite(target))return;const tick=()=>{const remaining=Math.max(0,Math.floor((target-Date.now())/1000));const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};Object.entries(values).forEach(([key,value])=>{el.querySelector('[data-unit="'+key+'"]').textContent=String(value).padStart(2,'0')});el.querySelector('.gjm-expired').hidden=remaining>0;if(remaining===0&&el.gjmTimer)clearInterval(el.gjmTimer)};tick();el.gjmTimer=setInterval(()=>{if(!el.isConnected){clearInterval(el.gjmTimer);return}tick()},1000)})}initGoodJinxCountdowns();document.addEventListener('shopify:section:load',initGoodJinxCountdowns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
